module.exports = __webpack_amd_options__;



//////////////////
// WEBPACK FOOTER
// (webpack)/buildin/amd-options.js
// module id = 122
// module chunks = 1 2 3 4 5 6 7 8 9